import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as InventaryService from "../../../../services/InventaryService";
import { useReadBigBag } from "../../standAloneProcess/hook/useReadBigBag";
import InventaryDetailView from "./inventaryDetail.view";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import * as XLSX from "xlsx";
import moment from "moment-timezone";
import { PROCESS_INVENTARY_OPEN } from "../../../../constants";

const InventaryDetailContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const { simpleReadBigBag, initial } = useReadBigBag();
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    InventaryService.processGetService(uuid).then((result) => {
      setData(result);
    });
  }, [uuid]);

  useEffect(() => {
    if (refresh) {
      InventaryService.processGetService(uuid).then((result) => {
        setData(result);
        setRefresh(false);
      });
    }
  }, [refresh, uuid]);

  const handlerOnCancel = () => {
    navigate(PATHS.INVENTARY_DETAIL);
  };

  const handlerOnSave = async () => {
    const values = {
      processUuid: data.uuid,
      numArticle: initial.itemCode,
      batch: initial.outBatch,
      weight: initial.outWeight,
    };

    try {
      let result = await InventaryService.addInventary(values);

      let title = "";
      let text = "";
      let icon = "";
      if (result) {
        setRefresh(true);
        // title = t("forms.inventary.messages.registerBB.title");
        // text = t("forms.inventary.messages.registerBB.text");
        // icon = "success";
      } else {
        title = "Error";
        text = t("forms.inventary.messages.registerBB.error");
        icon = "error";
        showDialog(title, text, icon, false, "OK", false, handlerOnCancel);
      }
    } catch (error) {
      console.error("Error saving inventary:", error);
      const errorCode = error.data.error.code;
      let errorMsg;
      if (errorCode === "INVENTARY.EXISTS") {
        errorMsg = t("forms.inventary.messages.addBigBag.error");
      } else {
        errorMsg = t("forms.inventary.messages.addBigBag.errorComun");
      }

      showDialog("Error", errorMsg, "error", false, "OK", false);
    }
  };

  const handlerOnFinish = async () => {
    let title = t("forms.inventary.dialog.closeProcess.title");
    let text = t("forms.inventary.dialog.closeProcess.text");

    let okAction = async () => {
      try {
        let result = await InventaryService.finishProcess(data.uuid);

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.inventary.messages.finish.title");
          text = t("forms.inventary.messages.finish.success");
          icon = "success";
          showDialog(title, text, icon, false, "OK", false, () => {
            setRefresh(true);
          });
        } else {
          title = "Error";
          text = t("forms.inventary.messages.finish.error");
          icon = "error";
          showDialog(title, text, icon, false, "OK", false);
        }
      } catch (error) {
        const errorCode = error.data.error.code;
        let errorMsg;
        let title = "Error";
        let icon = "error";

        if (errorCode === "PROCESS.UUID_NOT_FOUND") {
          errorMsg = t("forms.inventary.messages.finish.notFoundUuid");
        } else {
          errorMsg = t("forms.inventary.messages.finish.error");
        }

        showDialog(title, errorMsg, icon, false, "OK", false);
      }
    };

    const cancelAction = () => {};

    showDialog(
      title,
      text,
      "warning",
      true,
      t("forms.inventary.dialog.closeProcess.buttonOk"),
      false,
      okAction,
      t("forms.inventary.dialog.closeProcess.buttonNo"),
      cancelAction
    );
  };

  const exportToExcel = async () => {
    InventaryService.listToExport(data.uuid).then((result) => {
      const data = result.map((item) => {
        // const statusStock = STOCK_STATUS.find((c) => c.code === stock.status);
        return {
          A: item.batch,
          B: item.numArticle,
          C: item.descriptionArticle,
          D: item.weight,
          E: moment(item.date).format("DD-MM-yyyy HH:mm"),
          F: item.userToInventary.email,
          G: item.existingStock ? "En existencias" : "No hay Stock",
        };
      });
      data.unshift({
        A: "Lote",
        B: "nº Artículo",
        C: "Descripción Artículo",
        D: "Peso (Kg)",
        E: "Fecha",
        F: "Usuario",
        G: "Stock",
      });

      const filename = `Inventary_export_${moment(new Date()).format(
        "DDMMyyyyHHmm"
      )}`;
      const sheetName = "Listado de Inventario";
      var ws = XLSX.utils.json_to_sheet(data, {
        header: ["A", "B", "C", "D", "E", "F", "G"],
        skipHeader: true,
        UTC: true,
        dateNF: "dd-mm-yyyy hh:mm;@",
      });
      // dateNF:'mm/dd/yyyy;@',cellDates:true, raw: true}
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, filename + ".xlsx");
    });
  };
  const inventary = true;

  return (
    <>
      <div className="row justify-content-center mt-2">
        <div className="col-12 col-md-11">
          <div className="row">
            {data && data.status === PROCESS_INVENTARY_OPEN.code && (
              <div className="col-12">{simpleReadBigBag(inventary)}</div>
            )}
            <div className="col-12">
              <InventaryDetailView
                data={data}
                onCancel={handlerOnCancel}
                onSave={handlerOnSave}
                finish={handlerOnFinish}
                exportToExcel={exportToExcel}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

InventaryDetailContainer.propTypes = {};

export default InventaryDetailContainer;
